import { Injectable } from '@angular/core';

import { ICountriesApiClient } from './i-countries-api.client';
import { CountriesApiClient } from './countries-api.client';
import { CountriesInMemoryApiClient } from './countries.api.inmemory.client';
import { ApiClientProvider } from '../../../data-access';

@Injectable({
  providedIn: 'root'
})
export class CountriesApiClientProvider extends ApiClientProvider<ICountriesApiClient> {
  constructor(
    private client: CountriesApiClient,
    private inMemoryClient: CountriesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): ICountriesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): ICountriesApiClient {
    return this.client;
  }
}
